import React from "react";

import DesignSlider from "../cards/DesignSlider";
import { FromInt, numberSpace } from "../../helpers/NumberTools";

//icon
import CheckroomIcon from "@mui/icons-material/Checkroom";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import CompareIcon from "@mui/icons-material/Compare";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

//import eNums
import sizesEnum from "../../eNums/sizes.enum";

const printPlace = { front: "چاپ جلوی تیشرت", back: " چاپ پشت تیشرت" };

const BasketItemCard = (props) => {
  const { basketItem } = props;
  return (
    <div className="row cards">
      <div className="col-md-3 col-12">
        <div className="row justify-content-center" dir="ltr">
          <DesignSlider
            medias={basketItem.Draft.DraftItems[0].Design.DesignMedias}
          />
        </div>
      </div>
      <div className="col-md-9 col-12 ">
        <div className="col-12 ">
          <CheckroomIcon className="m-1" />{" "}
          {FromInt(`${basketItem.Draft.Material.title}`)}
        </div>
        <div className="col-12 ">
          <ColorLensIcon className="m-1" />{" "}
          {FromInt(`${basketItem.Draft.color}`)}
        </div>
        <div className="col-12 ">
          <FitScreenIcon className="m-1" />{" "}
          {FromInt(`${sizesEnum[basketItem.Draft.size]}`)}
        </div>
        <div className="col-12 ">
          <LocalPrintshopIcon className="m-1" />{" "}
          {`${basketItem.Draft.DraftItems[0].printSizeTxt}`}
        </div>
        <div className="col-12 ">
          <CompareIcon className="m-1" />{" "}
          {`${printPlace[basketItem.Draft.DraftItems[0].printPlace]}`}
        </div>
        <div className="col-12 ">
          <AttachMoneyIcon className="m-1" />{" "}
          {FromInt(numberSpace(`${basketItem.totalPrice}`))} تومان
        </div>
        {props.isOrder ? null : (
          <div className="col-12 float-left text-left">
            <IconButton
              aria-label="delete"
              size="large"
              color="error"
              onClick={() => props.deleteFromBasket(basketItem)}
            >
              <DeleteIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default BasketItemCard;
